import { c as _c } from "react/compiler-runtime";
import { selectedProjectSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Keep in sync with index.html:
export const DEFAULT_TITLE = "Sphere XG"; /* The title to set. Use undefined if you don't have all data to build the title yet. */

/**
 * Define the routes and respective document title
 */

/**
 * Sets the document.title based on the selected project and the current pathname.
 * This should be the only place where the title is set.
 *
 * Dashboard:              Sphere XG
 * Dashboard Project sel.: Project name
 * Registration:           Project name - Editor (not this codebase)
 * Viewer:                 Project name - Viewer (not this codebase)
 */
export function useDocumentTitle() {
  const $ = _c(6);
  const location = useLocation();
  const selectedProject = useAppSelector(selectedProjectSelector);
  let t0;
  if ($[0] !== location.pathname || $[1] !== selectedProject?.name) {
    t0 = () => {
      const projectName = selectedProject?.name;
      const titleMap = [{
        routePart: "/projects/active",
        title: DEFAULT_TITLE
      }, {
        routePart: "/projects/archived",
        title: DEFAULT_TITLE
      }, {
        routePart: "/projects/",
        title: projectName
      }, {
        routePart: "/",
        title: DEFAULT_TITLE
      }];
      let newTitle;
      for (const item of titleMap) {
        if (location.pathname.includes(item.routePart)) {
          newTitle = item.title;
          break;
        }
      }
      if (newTitle) {
        document.title = newTitle;
      }
    };
    $[0] = location.pathname;
    $[1] = selectedProject?.name;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== location.pathname || $[4] !== selectedProject) {
    t1 = [location.pathname, selectedProject];
    $[3] = location.pathname;
    $[4] = selectedProject;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  useEffect(t0, t1);
}